module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/general/cursor-6321f12c2a3906b9e1459a63cb7e81d5.svg";